import { parseCookies, setCookie } from 'nookies'

import { Icon, Text } from 'components'
import { ChangeEvent, useContext, useState } from 'react'
import { useToast, useToggle } from 'shared/hooks'

import { Loader, AvatarChangerModal } from '../../components'

import { useChangeProfileImage } from 'services/image'

import { UserContext } from 'shared/contexts/user/user'

import styles from './styles.module.scss'

const User = () => {
  const { profileImageURL, email, name } = parseCookies()
  const { setUser } = useContext(UserContext)

  const [newPhotoSrc, setNewPhotoSrc] = useState('')

  const { mutate, isLoading } = useChangeProfileImage()
  const { addToast } = useToast()
  const photoChangeModal = useToggle()

  const handlePhotoSelect = (event: ChangeEvent<HTMLInputElement>) => {
    event.preventDefault()
    if (event.target.files?.length) {
      const photoUrl = URL.createObjectURL(event.target.files[0])
      setNewPhotoSrc(photoUrl)
      photoChangeModal.show()

      // necessary to trigger onChange again if the user selects the same file
      event.target.value = ''
    }
  }

  const handlePhotoUpload = (imageBlob: Blob | MediaSource) => {
    photoChangeModal.hide()

    mutate(imageBlob as File, {
      onSuccess: (data) => {
        setUser((prev) => ({ ...prev, profileImageURL: data.address }))

        setCookie(undefined, 'profileImageURL', data.address, {
          maxAge: 60 * 600,
        })

        addToast({
          message: 'Imagem alterada com sucesso.',
        })
      },
      onError: () => {
        addToast({
          message: 'Erro ao alterar imagem. Tente novamente.',
          type: 'alert',
        })
      },
    })
  }

  return (
    <>
      {isLoading && <Loader />}

      {photoChangeModal.isVisible && (
        <AvatarChangerModal
          isVisible
          onClose={() => {
            setNewPhotoSrc('')
            photoChangeModal.hide()
          }}
          onSave={(image) => handlePhotoUpload(image)}
          avatarUrl={newPhotoSrc}
        />
      )}

      <div className={styles.container}>
        <div className={styles.avatar}>
          <div>
            {profileImageURL ? (
              <img src={profileImageURL} alt={name} />
            ) : (
              <Text color="element-bold" size="8xl">
                {name?.[0]}
              </Text>
            )}
          </div>
          <label htmlFor="avatar-edit">
            <div className={styles.edit}>
              <Icon name="edit" width={20} color="element-default" />

              <input
                type="file"
                id="avatar-edit"
                aria-label="avatar-edit-input"
                accept="image/*"
                onChange={handlePhotoSelect}
              />
            </div>
          </label>
        </div>
        <Text weight="bold" size="2xl">
          {email}
        </Text>
      </div>
    </>
  )
}

export default User
